// External libraries
import React, { useState } from 'react';
import { string } from 'prop-types';

// Internal modules
import { getContent } from '@/lib';
import { HonorFxButton, HonorFxContent } from './StyledComponents';

const FeeDisclosure = ({ feeRate }) => {
  const [isOpen, toggleIsOpen] = useState(false);
  const handleClick = () => toggleIsOpen(!isOpen);

  return (
    <>
      <p>
        {getContent('currencyConversion.paypalDisclosure.feeRate', { feeRate })}
      </p>

      <HonorFxButton isOpen={isOpen} onClick={handleClick}>
        {getContent('currencyConversion.paypalDisclosure.honorFx.button')}
      </HonorFxButton>

      {isOpen && (
        <HonorFxContent>
          {getContent('currencyConversion.paypalDisclosure.honorFx.content')}
        </HonorFxContent>
      )}
    </>
  );
};

FeeDisclosure.propTypes = {
  feeRate: string,
};

export { FeeDisclosure };
